module.exports = __webpack_public_path__ + "img/sugarcane-350x184.e1df830e.jpg";